import { render, staticRenderFns } from "./AppHubNotch.vue?vue&type=template&id=03dbeb56&scoped=true&"
import script from "./AppHubNotch.vue?vue&type=script&lang=js&"
export * from "./AppHubNotch.vue?vue&type=script&lang=js&"
import style0 from "./AppHubNotch.vue?vue&type=style&index=0&id=03dbeb56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbeb56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VMenu,VTooltip})
